import { computed, inject, type ComputedRef } from 'vue';

export const OFFER_VERIFIED_INJECTION_KEY = Symbol();

export type OfferVerifiedInjectionProps = {
	isFetching: ComputedRef<boolean>;
	isVerified: ComputedRef<boolean>;
	isNotAvailable: ComputedRef<boolean>;
	isPackage: ComputedRef<boolean>;
};

export const useOfferVerifiedInjection = (): OfferVerifiedInjectionProps => {
	return inject<OfferVerifiedInjectionProps>(OFFER_VERIFIED_INJECTION_KEY, {
		isFetching: computed(() => false),
		isVerified: computed(() => false),
		isNotAvailable: computed(() => false),
		isPackage: computed(() => false),
	});
};
